var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatagram1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 31.5",
    style: {
      enableBackground: "new 0 0 32 31.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E9B800;stroke:#000000;stroke-linejoin:round;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st3{fill:#2200C9;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "15,22 20,22 18,31 31,19 26,19 27,14 22,14  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14,29H3c-1.1,0-2-0.9-2-2V3c0-1.1,0.9-2,2-2h26c1.1,0,2,0.9,2,2v11"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 1,
    y1: 7,
    x2: 31,
    y2: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20.5,3h1C21.8,3,22,3.2,22,3.5v1C22,4.8,21.8,5,21.5,5h-1C20.2,5,20,4.8,20,4.5v-1C20,3.2,20.2,3,20.5,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23.5,3h1C24.8,3,25,3.2,25,3.5v1C25,4.8,24.8,5,24.5,5h-1C23.2,5,23,4.8,23,4.5v-1C23,3.2,23.2,3,23.5,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.5,3h1C27.8,3,28,3.2,28,3.5v1C28,4.8,27.8,5,27.5,5h-1C26.2,5,26,4.8,26,4.5v-1C26,3.2,26.2,3,26.5,3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatagram1);
export default __webpack_public_path__ + "static/media/datagram_1.a1c03106065fa9c6ac9c92b25b5a2311.svg";
export { ForwardRef as ReactComponent };